import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-50">
      <div className="w-full px-6 md:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="inline-block mb-4">
              <span className="text-xl font-heading font-bold text-background-50 tracking-tight">
                Pandabuy<span className="text-accent-400">Spreadsheet</span>
              </span>
            </Link>
            <p className="text-sm text-background-300/70 leading-relaxed">
              The #1 curated Pandabuy spreadsheet discovery hub. Find trending fashion, sneakers, and accessories organized into easy-to-browse lists.
            </p>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-background-300/50 mb-5">Stay Updated</h4>
            <div className="relative">
              <input
                type="text"
                placeholder="Your email address"
                className="w-full bg-transparent border-0 border-b border-background-300/30 pb-2 text-sm text-background-100 placeholder:text-background-300/40 focus:outline-none focus:border-accent-400 transition-colors"
              />
              <button className="absolute right-0 top-0 text-background-300/60 hover:text-accent-400 transition-colors cursor-pointer">
                <i className="ri-arrow-right-line text-lg"></i>
              </button>
            </div>
            <p className="text-xs text-background-300/40 mt-3">
              No spam. Visit{" "}
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-accent-400 hover:text-accent-300 transition-colors">
                kaspreadsheet.com
              </a>
            </p>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-background-300/50 mb-5">Quick Links</h4>
            <div className="flex flex-col gap-3">
              <Link to="/" className="text-sm text-background-300/70 hover:text-background-50 transition-colors">Home</Link>
              <Link to="/pandabuy-spreadsheet-guide" className="text-sm text-background-300/70 hover:text-background-50 transition-colors">Complete Guide</Link>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-background-300/70 hover:text-background-50 transition-colors">Main Store</a>
            </div>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-background-300/50 mb-5">External Links</h4>
            <div className="flex flex-col gap-3">
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-background-300/70 hover:text-background-50 transition-colors">
                Pandabuy Sheet
              </a>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-background-300/70 hover:text-background-50 transition-colors">
                Buy It Now
              </a>
              <a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-background-300/70 hover:text-background-50 transition-colors">
                Shoes Category
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-background-300/10">
        <div className="w-full px-6 md:px-10 py-8">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <div className="text-5xl md:text-7xl font-heading font-extrabold text-background-300/10 tracking-tighter select-none">
              PANDABUYSHEET
            </div>
            <p className="text-xs text-background-300/30 whitespace-nowrap">
              &copy; 2026 PandabuySpreadsheet. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}